import gql from 'graphql-tag';

const IMAGE_FRAGMENT = gql`
  fragment ImageFragment on Image {
    acv_large
    acv_medium
    acv_loading
    image_key
    thumbnail
    acv_thumbnail
    url
    update
  }
`;

export default IMAGE_FRAGMENT;
